import axios from "axios";
import { redirectIfStoreUnavailableMessage } from "./storeUnavailable";

const apiUserTienda = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 25000,
});

apiUserTienda.interceptors.request.use((config) => {
  const token = localStorage.getItem("tienda_token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

apiUserTienda.interceptors.response.use(
  (response) => {
    if (response?.data?.ok === false) {
      const allErrs = Array.isArray(response?.data?.errors)
        ? response.data.errors.map((e) => e?.msg).filter(Boolean).join(" · ")
        : null;

      const msg =
        response?.data?.message ||
        allErrs ||
        response?.data?.error ||
        "La solicitud falló";

      redirectIfStoreUnavailableMessage(msg);

      const err = new Error(msg);
      err.status = 400;
      err.code = response?.data?.code || "REQUEST_FAILED";
      err.data = response?.data;
      throw err;
    }

    return response;
  },
  (error) => {
    const status = error?.response?.status || 0;
    const data = error?.response?.data || null;

    const allErrs = Array.isArray(data?.errors)
      ? data.errors.map((e) => e?.msg).filter(Boolean).join(" · ")
      : null;

    const backendMsg =
      data?.message ||
      allErrs ||
      data?.error ||
      null;

    redirectIfStoreUnavailableMessage(backendMsg);

    const message =
      backendMsg ||
      (status === 401 ? "Sesión expirada. Inicia sesión nuevamente." : null) ||
      (status === 403 ? "No tienes permiso para realizar esta acción." : null) ||
      (status === 404 ? "Recurso no encontrado." : null) ||
      (status >= 500 ? "Error del servidor. Intenta más tarde." : null) ||
      error?.message ||
      "Error inesperado";

    const err = new Error(message);
    err.status = status;
    err.code = data?.code || "UNKNOWN";
    err.data = data;

    return Promise.reject(err);
  }
);

export default apiUserTienda;